<ng-container *transloco="let t; read: 'widgets.newspaper-widglet'">
  <div class="newspaper-widglet__header">
    <h3>{{ t('header') }}</h3>

    <span>{{ t('subheader', { date: creationDate | date: 'yyyy-MM-dd HH:mm:ss' }) }}</span>

    <div class="newspaper-widglet__actions">
      @if (hasChanges) {
        <xi-icon-button
          icon="refresh"
          color="CX"
          [tooltip]="{ text: t('refresh') }"
          (onClick)="generateNewspaper()"
          class="newspaper-widglet__refresh-button"
        ></xi-icon-button>
      }
    </div>
  </div>

  @if (stories) {
    <div class="newspaper-widglet__content">
      @if (!stories.length) {
        <h3 class="newspaper-widglet__no-documents">
          {{ t('no-documents') }}
        </h3>
      }
      @for (story of stories; track story) {
        <section class="newspaper-widglet__story">
          <p class="newspaper-widglet__story-heading">{{ story.heading }}</p>
          @for (content of story.contents; track content) {
            <p [innerHTML]="content.subHeader" class="newspaper-widglet__story-subheader"></p>
            @if (hasInsight(content)) {
              <p class="newspaper-widglet__story-insight">
                <xi-icon icon="lightbulb" iconSize="small" color="CX"></xi-icon>
                @if (content.insight) {
                  <span>{{ content.insight }}</span>
                } @else {
                  <span class="newspaper-widglet__story-insight--preparing ellipsis-loader"
                    >{{ t('story-being-prepared') }}
                  </span>
                }
              </p>
            }
          }
        </section>
      }
    </div>
  }
</ng-container>

@if (isGenerating) {
  <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}
